const componentVisibleFunction = (componentConfig, componentProps) => {
    if (componentConfig?.style?.visible) {
        const { $vuetify, $store, $booking } = window;
        let visible = componentConfig.style.visible;

        if (!visible.type || !Array.isArray(visible.type) || visible.type.includes('always')) {
            return null;
        }

        let permissions = visible.permissions || [];
        let roles = visible.roles || [];
        let cards = visible.cards || [];

        let functions = visible.type.map(vt => {
            const map = {
                never: () => false,
                isLoggedIn: () => $store.state.isLoggedIn,
                isNotLoggedIn: () => !$store.state.isLoggedIn,
                desktop: () => !$vuetify.breakpoint.mobile,
                mobile: () => $vuetify.breakpoint.mobile,
                card: () => $store.state.cards?.some(x => {
                    return cards.includes(x.cardtype_id) &&
                    $booking.isCardValid(x, $store.state.now30s.clone().clearTime())
                }),
                role: () => $store.state.user?.roles.some(x => roles.includes(x.id)),
                permission: () => permissions.every(x => $store.state.user?.permissions.includes(x)),
                advanced: visible.code
            };

            let code = map[vt] ?? map['never'];

            let f = typeof code === 'string' ? new Function(code) : code;
            f = f.bind({
                $vuetify,
                $store,
                $booking,
                props: componentProps
            });

            return f;
        })

        return () => functions.every(f => {
            let result = false;
            try {
                result = f();
            }
            catch(error) {
                console.log('Visible function execution error')
                console.log(error);
            }
            return result;
        });
    } else {
        return null;
    }
}

export { componentVisibleFunction }
